import React from 'react'

export const setCodeToElement = (set: string, rarity: string, className?: string) => {
  const iconClassName = `ss ss-${set.toLowerCase()} ss-${rarity.toLowerCase()} ss-grad `

  return <i className={`${iconClassName} ${className}`} style={{ fontSize: '150%' }} />
}
